import { GridFilterConfig } from '../index';

type FilterValues = { [name: string]: any };
type Dependent = Pick<GridFilterConfig, 'dependsOn'>;

const isEmpty = (value: any): boolean =>
    value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0);

export function parentValue(config: Dependent, filterValues: FilterValues): string {
    if (!config.dependsOn) return '';
    const value = filterValues[config.dependsOn];

    return isEmpty(value) ? '' : String(value);
}

/** A filter without dependsOn is always satisfied; a dependent one needs its parent selected. */
export function hasParentValue(config: Dependent, filterValues: FilterValues): boolean {
    return !config.dependsOn || parentValue(config, filterValues) !== '';
}

export function resolveDependentUrl(
    dataUrl: string | undefined,
    dependsOn: string | undefined,
    value: string,
): string | undefined {
    if (!dataUrl || !dependsOn) return dataUrl;

    return dataUrl.split(`{${dependsOn}}`).join(encodeURIComponent(value));
}

export function dependentFilterNames(filtersList: GridFilterConfig[][], parentName: string): string[] {
    return filtersList
        .flat()
        .filter((filter) => filter.dependsOn === parentName)
        .map((filter) => filter.name);
}
